<template><div>
<mu-appbar  class="syn-navbar">
    <mu-flat-button href="#/driver" label="Fiche Chauffeur" class="syn-nav-button" slot="left" icon="arrow_back"/>
</mu-appbar>
<!-- Formulaire -->
<div class="syn-content">
    <mu-paper class="card-paper" rounded :zDepth="1" >
        <div class="card-toolbar">
            <span class="card-toolbar-title">Fiche de {{form.name}}</span>
            <span><a href="#/driver"><mu-icon value="close"/></a></span>
        </div>
        <div class="card-content">
        <mu-row gutter>
            <mu-col width="100" tablet="50" desktop="50">
                <mu-text-field label="Nom" labelFloat v-model="form.name" lazy /><br />
                <mu-text-field label="Prénom" labelFloat v-model="form.firstname" lazy /><br />
                <mu-text-field label="Abrege" labelFloat v-model="form.abrege" lazy /><br />
                <mu-text-field label="Mobile" labelFloat v-model="form.tel1" lazy /><br />
                <mu-text-field label="Tel2" labelFloat v-model="form.tel2" lazy /><br />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50">
                <mu-text-field label="Adresse" labelFloat v-model="form.address" lazy /><br />
                <mu-text-field label="Code postale" labelFloat v-model="form.cp" lazy /><br />
                <mu-text-field label="Ville" labelFloat v-model="form.ville" lazy /><br />
                <mu-text-field label="Courriel" labelFloat v-model="form.email" lazy /><br />
                    <mu-select-field v-model="form.liv_sta_id" :labelFocusClass="['label-foucs']" label="Statut">
                    <mu-menu-item v-for="(text, index) in staList" :key="index" :value="index" :title="text" />
                </mu-select-field>
            </mu-col>
        </mu-row>
        </div>
        <div class="text-right">
            <mu-raised-button @click="saveForm" :disabled="saveProgress" label="Enregistrer" icon="save" backgroundColor="#8bc34a"/>
            <mu-raised-button href="#/driver" :disabled="saveProgress" label="Annuler" />
        </div>
    </mu-paper>
</div>
</div></template>

<script>
import icon         from 'muse-components/icon'
import iconButton   from 'muse-components/iconButton'
import appBar       from 'muse-components/appBar'
import flatButton   from 'muse-components/flatButton'
import textField    from 'muse-components/textField'
import raisedButton from 'muse-components/raisedButton'
import paper        from 'muse-components/paper'
import selectField  from 'muse-components/selectField'
import {menu, menuItem}  from 'muse-components/menu'
import dropDownMenu  from 'muse-components/dropDownMenu'
import {row, col}   from 'muse-components/grid'

export default {
  name: 'driver_card',
  data: function () {
    return {
        saveProgress: false,                  // Enregistrement en cours...
        staList: { 
            GEN01:'Activé',GEN03:'Désactivé'
        },
        form:{
            rowid: 0, dos: '',
            fk_user: '', usertyp: '', type: '', radio: '', fk_truck: '',
            abrege: '', terminal: '',
            name: '', pass: '', firstname: '',
            address: '', cp: '', ville: '',
            tel1: '', tel2: '', fax: '', email: '', fk_tarif: '', opt_tarif: '',
            liv_sta_id: 'GEN01',
            _method: 'POST',
            _path: 'driver'
        },
    }
  },
  mounted:function (){
    if( this.$route.params.id !== undefined && this.$route.params.id !== 'ajouter' ){
        window.axios.post( '/', { _method:'GET', _path:'driver/' + this.$route.params.id } )
        .then( (response) => {
            var prop
            for( prop in response.data ){
                if( this.form[prop] !== undefined ){
                    this.form[prop] = response.data[prop] 
                }
            }
        })
    }
  },
  methods: {
    saveForm () {
    // Enregistrement du formulaire
        this.saveProgress = true
        window.axios.post( '/', this.form )
        .then( (response) => {
            this.$parent.toast()
            this.$router.push({ path: '/driver' })
        }).catch(function (error) {
            console.log(error);
        });
    }
  },
  components: {
      'mu-icon': icon,
      'mu-icon-button': iconButton,
      'mu-appbar': appBar,
      'mu-text-field': textField,
      'mu-flat-button': flatButton,
      'mu-raised-button': raisedButton,
      'mu-paper': paper,
      'mu-row': row,
      'mu-col': col,
      'mu-select-field': selectField,
      'mu-drop-down-menu': dropDownMenu,
      'mu-menu': menu,
      'mu-menu-item': menuItem
  }
}
</script>


// WEBPACK FOOTER //
// Driver_card.vue?4c42192e